import {InjectionToken} from '@angular/core';

export const RESPONSE = new InjectionToken<Response>('RESPONSE');
